import '../enums/call-direction.js';
import { HttpVerb } from '../enums/http.js';
import '../enums/meeting-info-provider.js';
import '../enums/provider-name.js';
import '../enums/user-profile-entitlement.js';
import '../enums/user-profile-schema.js';
import { __extends } from '../_virtual/_tslib.js';
import { defer, timer } from 'rxjs';
import { map, retryWhen, delayWhen, mapTo } from 'rxjs/operators';

/* istanbul ignore next */
var HttpResponseError = /** @class */ (function (_super) {
    __extends(HttpResponseError, _super);
    function HttpResponseError(message, responseData, status, statusText) {
        var _this = _super.call(this, message) || this;
        _this.responseData = responseData;
        _this.status = status;
        _this.statusText = statusText;
        _this.name = 'HttpResponseError';
        Object.setPrototypeOf(_this, HttpResponseError.prototype);
        return _this;
    }
    return HttpResponseError;
}(Error));
var responseHandler = function (_a) {
    var status = _a.status, statusText = _a.statusText, data = _a.data;
    if (status >= 400 && status <= 500) {
        throw new HttpResponseError(status + ": " + statusText, data, status, statusText);
    }
    return data;
};
var createSwallowErrorCodesResponseHandler = function (errorCodesToSwallow) { return function (httpResponseData) {
    if (errorCodesToSwallow.includes(httpResponseData.status)) {
        return httpResponseData.data;
    }
    return responseHandler(httpResponseData);
}; };
var callApiWithStandardResponse = function (httpClient, verb, apiUrl, body, params) {
    var apiCall$;
    switch (verb) {
        case HttpVerb.DELETE:
            apiCall$ = httpClient.delete(apiUrl, params);
            break;
        case HttpVerb.HEAD:
            apiCall$ = httpClient.head(apiUrl, params);
            break;
        case HttpVerb.GET:
            apiCall$ = httpClient.get(apiUrl, params);
            break;
        case HttpVerb.PATCH:
            apiCall$ = httpClient.patch(apiUrl, body, params);
            break;
        case HttpVerb.POST:
            apiCall$ = httpClient.post(apiUrl, body, params);
            break;
        case HttpVerb.PUT:
            apiCall$ = httpClient.put(apiUrl, body, params);
            break;
        default:
            throw new Error('No valid HttpVerb Specified');
    }
    return apiCall$.pipe(map(responseHandler));
};
var exponentialBackoff = function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.attempts, attempts = _c === void 0 ? 3 : _c, _d = _b.shouldRetry, shouldRetry = _d === void 0 ? function () { return true; } : _d;
    return retryWhen(function (errors$) {
        return defer(function () {
            var attempt = 0;
            return errors$.pipe(map(function (error) {
                if (shouldRetry(error) && attempt < attempts) {
                    attempt++;
                    return error;
                }
                else {
                    throw error;
                }
            }), delayWhen(function (error, index) { return timer(100 * Math.pow(2, index)).pipe(mapTo(error)); }));
        });
    });
};

export { HttpResponseError, callApiWithStandardResponse, createSwallowErrorCodesResponseHandler, exponentialBackoff, responseHandler };
